const AppLoader = () => (
  <div
    className="appLoader"
    role="status"
    aria-live="polite"
    aria-label="Loading"
  >
    Loading...
  </div>
);

export default AppLoader;
